module.exports = __webpack_public_path__ + "img/教学指挥中心.2922b739.png";